import { APIParser } from './api-parser';
import { NEW_API_URL } from './api-client';
import { createFetchGetOptions, getToken } from './api-util.js';

function createFetchPostOptions(body) {
    const token = getToken();
    return {
        method: 'POST',
        body,
        withCredentials: true,
        credentials: 'include',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
}

//only the document info and the slide images
export const GetPowerpointImagePreviews = (taskID) => {
    return fetch(
        NEW_API_URL + '/Tasks/GetPowerpointImagePreviews/' + taskID,
        createFetchGetOptions()
    ).then((response) => APIParser(response));
};

//returns current ppt file in base 64, needs id of file in FileStorage Table
export const GetTaskDocumentPowerpoint = (docId) => {
    return fetch(
        NEW_API_URL + '/Tasks/GetTaskDocumentPowerpoint/' + docId,
        createFetchGetOptions()
    ).then((response) => APIParser(response));
};

export const ApprovePowerPointTask = (formData) => {
    return fetch(
        NEW_API_URL + '/Tasks/SubmitTaskPowerPointDocument',
        createFetchPostOptions(formData)
    ).then((response) => APIParser(response));
};

export const DeclinePowerPointTask = (formData) => {
    return fetch(
        NEW_API_URL + '/Tasks/DeclineTaskPowerPointDocument',
        createFetchPostOptions(formData)
    ).then((response) => APIParser(response));
};

export const AddPowerPointComment = (formData) => {
    return fetch(
        NEW_API_URL + '/Tasks/AddTaskCommentLegacy',
        createFetchPostOptions(formData)
    ).then((response) => APIParser(response));
};

export const CancelPowerPointTask = (formData) => {
    return fetch(NEW_API_URL + '/Tasks/CancelTask', createFetchPostOptions(formData)).then(
        (response) => APIParser(response)
    );
};

export const DownloadCommentAttachment = (id) => {
    return fetch(NEW_API_URL + '/Tasks/DownloadCommentAttachment/' + id, createFetchGetOptions());
};

export const DownloadPPTVersionDocument = (id, formData) => {
    return fetch(
        NEW_API_URL + '/Tasks/DownloadPPTVersionDocument/' + id,
        createFetchPostOptions(formData)
    );
};

export const GetTask = (id) => {
    return fetch(NEW_API_URL + '/Tasks/GetTask/' + id, createFetchGetOptions()).then((response) =>
        APIParser(response)
    );
};
